import { render, staticRenderFns } from "./DomainClaimResolutionContent.vue?vue&type=template&id=464c4b31&scoped=true"
import script from "./DomainClaimResolutionContent.vue?vue&type=script&lang=ts"
export * from "./DomainClaimResolutionContent.vue?vue&type=script&lang=ts"
import style0 from "./DomainClaimResolutionContent.vue?vue&type=style&index=0&id=464c4b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c4b31",
  null
  
)

export default component.exports